import {
  GAME_ID,
  REDUX_ACTIONS,
  MIN_TRIES_FOR_MASTERY,
  AVAILABLE_LEVEL_INDEXES,
} from '../../data/constants';

const initialState = {
  mistakesMadeInDocuments: {},
  masteredDocuments: [],
  highestLevelMastered: 0,
};

const masteryReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_LEVEL:
      return {
        ...initialState,
        mistakesMadeInDocuments: payload.documents.reduce((obj, addition) => ({
          ...obj,
          [addition.id]: 0,
        }), {}),
      };
    case REDUX_ACTIONS.COMPLETE_STD_ITEM: {
      const masteredDocuments = [...state.masteredDocuments];
      if (state.mistakesMadeInDocuments[payload.documentId] < MIN_TRIES_FOR_MASTERY) {
        if (!masteredDocuments.includes(payload.documentId)) {
          masteredDocuments.push(payload.documentId);
        }
      }
      return {
        ...state,
        masteredDocuments,
      };
    }
    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT:
      return {
        ...state,
        mistakesMadeInDocuments: {
          ...state.mistakesMadeInDocuments,
          [payload.documentId]: state.mistakesMadeInDocuments[payload.documentId] + 1,
        },
      };
    case REDUX_ACTIONS.MASTER_LEVEL: {
      let { highestLevelMastered } = state;
      const masteredLevelIndex = AVAILABLE_LEVEL_INDEXES.findIndex(e => e === payload);
      if (masteredLevelIndex < AVAILABLE_LEVEL_INDEXES.length - 1) {
        highestLevelMastered = AVAILABLE_LEVEL_INDEXES[masteredLevelIndex + 1];
      }
      return {
        ...state,
        highestLevelMastered,
      };
    }

    case REDUX_ACTIONS.MERGE_GAME_STATE: {
      const { mastery } = payload;
      if (mastery) {
        return {
          ...state,
          ...mastery,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default masteryReducer;
